import React from 'react';
import UWLogo from '../../assets/UW_Horizontal_Logo_Full.png';
import PrepLogo from '../../assets/Prep-Logo.png';

const PsychometricTestNavbar = ({ signedOrganization }) => {
  const navbarStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    backgroundColor: 'white',
  };

  const logoStyle = {
    height: '40px',
    width: 'auto',
  };

  return (
    <nav style={navbarStyle}>
      <div>
        <img src={UWLogo} alt="UW Logo" style={logoStyle} />
      </div>
      {signedOrganization === 'Prep.Study' && (
        <div>
          <img src={PrepLogo} alt="Prep Logo" style={logoStyle} />
        </div>
      )}
    </nav>
  );
};

export default PsychometricTestNavbar;
